import { FC } from 'react';

import { ClickAwayListener, Popper, PopperProps } from '@mui/material';
import clsx from 'clsx';

import styles from './Popper.module.scss';

interface IPopperProps extends PopperProps {
  onClose: () => void;
}

export const PopperComponent: FC<IPopperProps> = ({
  open,
  anchorEl,
  placement = 'bottom-start',
  children,
  container,
  className: popperClassName,
  onClose,
}) => {
  return (
    <>
      {open && (
        <ClickAwayListener onClickAway={onClose}>
          <Popper
            className={clsx(styles.wrapper, popperClassName && popperClassName)}
            open={open}
            placement={placement}
            anchorEl={anchorEl}
            container={container}
          >
            {children}
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
};
